import { Image, File, Message } from '@tribeplatform/gql-client/types'

import { ChatAttachment, DraftMessage, DraftMessageType } from '../types.js'

import {
  SendMessageToNewChatParams,
  SendMessageToExistingChatParams,
} from './types.js'

export const getAttachmentsToSend = (chatAttachments: ChatAttachment[]) => {
  const attachments = chatAttachments
    .filter(({ type }) => type === 'file')
    .map(({ uploadedFile }) => uploadedFile) as File[]
  const images = chatAttachments
    .filter(({ type }) => type === 'image' || type === 'giphy')
    .map(({ uploadedFile }) => uploadedFile) as Image[]

  const attachmentsIds = attachments.map(({ id }) => id)
  const imagesIds = images.map(({ id }) => id)

  return {
    attachments,
    images,
    attachmentsIds,
    imagesIds,
  }
}

export const isAlreadyEditingMessage = (
  draftMessage: DraftMessage,
  message: Message,
) => {
  return (
    draftMessage.type === DraftMessageType.Edit &&
    draftMessage.originalMessage._id === message._id
  )
}

export const messageToDraftMessage = (message: Message): DraftMessage => {
  const fileAttachments = message.attachments.map(
    att =>
      ({
        id: att.id,
        type: 'file',
        uploadedFile: att,
      }) satisfies ChatAttachment,
  )
  const imageAttachments = message.images.map(
    img =>
      ({
        id: img.id,
        type: 'image',
        uploadedFile: img,
      }) satisfies ChatAttachment,
  )
  const attachments = [...fileAttachments, ...imageAttachments]

  const newDraftMessage: DraftMessage = {
    type: DraftMessageType.Edit,
    originalMessage: message,
    attachments,
    embeds: message.embeds ?? [],
    content: message.content,
  }

  return newDraftMessage
}

export const isGiphyMessage = (
  params: SendMessageToNewChatParams | SendMessageToExistingChatParams,
): params is typeof params & {
  isSendingGiphy: true
  giphyAttachments: ChatAttachment[]
} => {
  return !!params.isSendingGiphy
}
